<template>
  <v-dialog
    v-model="getModalImprimirEtiqueta"
    scrollable
    fullscreen
    persistent
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        Impressão de Etiquetas
      </v-card-title>
      <v-card-text>
        <v-form ref="formProduto" class="mt-3">
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-select
                label="Etiqueta"
                :items="['', ...getEtiquetas]"
                item-text="nome"
                item-value="id"
                v-model="modelo_etiqueta_id"
                class="mr-2 ml-2"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                label="Código"
                v-model="produto.id"
                outlined
                dense
                class="mr-2 ml-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8>
              <v-autocomplete
                label="Produto"
                :items="['', ...getProdutos]"
                item-text="descricao"
                item-value="id"
                v-model="produtoSelect"
                class="mr-2 ml-2"
                outlined
                dense
                return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                label="Quantidade"
                v-model="produto.quantidade"
                outlined
                dense
                append-outer-icon="control_point"
                @click:append-outer="addProduto"
                class="mr-2 ml-2"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Cód.</th>
              <th>Descrição</th>
              <th>Quantidade</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in produtos" :key="p.id">
              <td>{{ p.id }}</td>
              <td>{{ p.descricao }}</td>
              <td>{{ p.quantidade }}</td>
              <td>
                <v-btn
                  x-small
                  color="error"
                  @click="removerProduto(p)"
                  outlined
                >
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      </v-card-text>
      
      <v-card-actions> 
        <v-btn color="default" outlined dense @click="setModalImprimirEtiqueta(false)">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" outlined dense @click="imprimir()">Imprimir</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <ModalPesquisarProduto /> -->
  </v-dialog>
</template>
<script>
// import ModalPesquisarProduto from "@/pages/produto/ModalPesquisarProduto";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    // ModalPesquisarProduto,
  },
  data() {
    return {
      produtos: [],
      produto: {},
      produtoSelect: {},
      modelo_etiqueta_id: "",
    };
  },
  watch: {
    getModalImprimirEtiqueta(){
      if(this.getModalImprimirEtiqueta == true){
        this.produtos = [],
        this.modelo_etiqueta_id = "",
        this.produtoSelect = {}
        // this.produto = ""
      }
    }
  },
  computed: {
    ...mapGetters([
      "getProduto",
      "getModalImprimirEtiqueta",
      "getProdutos",
      "getEtiquetas"
    ]),
  },
  methods: {
    ...mapActions([
      "setModalPesquisarProduto",
      "listarProdutos",
      "setModalImprimirEtiqueta",
      "listarProdutos",
      "imprimirEtiqueta"
    ]),
    addProduto() {
      if(this.produtoSelect.id == "" || !this.produtoSelect.id) {
        this.$store.commit('snackbarError', 'Iforme um produto.');
        return
      }

      if(this.produto.quantidade == "" || !this.produto.quantidade || this.produto.quantidade == 0) {
        this.$store.commit("snackbarError", "Informe a quandidade")
        return
      }

      this.produto.descricao = this.produtoSelect.descricao;;
      this.produto.id = this.produtoSelect.id
      this.produto.preco_venda = this.produtoSelect.preco_venda
      this.produtos.unshift({...this.produto});
      this.produtoSelect = {}
      this.produto = {}
    },
    imprimir(){
      if(this.produtos.length == 0) {
        this.$store.commit("snackbarError", "Informe um produto.");
        return
      }

      if(this.modelo_etiqueta_id == "" || !this.modelo_etiqueta_id){
        this.$store.commit("snackbarError", "Seleciona a etiqueta.");
        return
      }

      this.imprimirEtiqueta({
        modelo_etiqueta_id: this.modelo_etiqueta_id,
        produtos: this.produtos
      })
    },
    removerProduto(payload) {
      let index = this.produtos.map((x) => x).indexOf(payload);
      this.produtos.splice(index, 1);
    },
  },
  created(){
    this.listarProdutos({})
  }
};
</script>
